import api from '../api';
import {
  VaccinationCampaign,
  UserVaccination,
  VaccinationSchema,
  PostUserVaccination,
} from '../models/vaccination';

class VaccinationService {
  public async getActiveCampaign() {
    return api.get<VaccinationCampaign>('/pwa/vaccination-campaign/active');
  }

  public async getActiveCampaignTaken() {
    return api.get<{ scheduledDate: Date }[]>(
      '/pwa/vaccination-schedule/active/taken'
    );
  }

  public async getCurrentUserActiveCampaignInformation() {
    return api.get<UserVaccination>('/pwa/user-vaccination/active');
  }
  public setVaccinationStatus = async (
    user_vaccination_id: number,
    data: VaccinationSchema
  ) =>
    api.post<UserVaccination>(
      `/pwa/user-vaccination/${user_vaccination_id}`,
      data
    );

  public async postUserVaccination(data: PostUserVaccination) {
    return api.post<UserVaccination>('/pwa/user-vaccination/active', data);
  }
}

export default new VaccinationService();
